module.exports = __webpack_public_path__ + "static/media/icon_syune644598c13b6977e49fb9f16057c82e8.webp";